const asBool = (value: string | undefined): boolean => value === 'true';

export interface ConfigState {
    disableRentalWriteActions: boolean;
    backend: {
        AUTHENTICATION_SERVICE: string | undefined;
        MENU_SERVICE: string | undefined;
        ASSET_ADMINISTRATION: string | undefined;
        RENTAL_SERVICE: string | undefined;
    };
    homeRoute: string | undefined;
    helpGangHomeRoute: string | undefined;
    id: string | undefined;
    login: {
        authority: string | undefined;
        clientId: string | undefined;
        oauthScope: string[];
        mockAuthorization: boolean;
        mockLocale: string | undefined;
        mockTenant: string | undefined;
        preventRedirect: boolean;
        redirectUri: string | undefined;
        silentRedirectUri: string | undefined;
        postLogoutRedirectUri: string | undefined;
    };
    serviceVersion: string;
    serviceEnvironment: string;
    enableMockServer: boolean;
    logoutUri: string | undefined;
    sentryToken: string | undefined;
    sentryModuleName: string;
    datadog: {
        clientToken: string;
        tags: {
            version: string | undefined;
            service: string;
            teamIdentifier: string;
            awsAccountId: string;
            awsAccountName: string;
        };
    };
    applicationName: string;
    partnerNetworkOverviewUrl: string | undefined;
    partnerNetworkOverviewOnboardingUrl: string | undefined;
    eulaUrl: string | undefined;
    releaseVersion: string;
}

export const config: ConfigState = {
    disableRentalWriteActions: asBool(import.meta.env.VITE_DISABLE_RENTAL_WRITE_ACTIONS ?? 'false'),
    backend: {
        AUTHENTICATION_SERVICE: import.meta.env.VITE_AUTHENTICATION_SERVICE,
        MENU_SERVICE: import.meta.env.VITE_MENU_SERVICE,
        ASSET_ADMINISTRATION: import.meta.env.VITE_ASSET_ADMIN_BASE_URL,
        RENTAL_SERVICE: import.meta.env.VITE_RENTAL_SERVICE_BASE_URL,
    },
    homeRoute: import.meta.env.VITE_HOME_ROUTE,
    helpGangHomeRoute: import.meta.env.VITE_HELP_GANG_HOME_ROUTE,
    id: import.meta.env.VITE_ID,
    login: {
        authority: import.meta.env.VITE_LOGIN_AUTHORITY,
        clientId: import.meta.env.VITE_LOGIN_CLIENT_ID,
        oauthScope: ['openid', 'profile', 'email'],
        mockAuthorization: import.meta.env.DEV,
        mockLocale: import.meta.env.VITE_LOGIN_MOCK_LOCALE,
        mockTenant: import.meta.env.VITE_LOGIN_MOCK_TENANT,
        preventRedirect: asBool(import.meta.env.VITE_LOGIN_PREVENT_REDIRECT),
        redirectUri: import.meta.env.VITE_LOGIN_REDIRECT_URI,
        silentRedirectUri: import.meta.env.VITE_LOGIN_SILENT_REDIRECT_URI,
        postLogoutRedirectUri: import.meta.env.VITE_LOGIN_POST_LOGOUT_REDIRECT_URI,
    },
    serviceVersion: APP_VERSION,
    serviceEnvironment: import.meta.env.MODE,
    enableMockServer: import.meta.env.DEV,
    logoutUri: import.meta.env.VITE_LOGOUT_URI,
    sentryToken: import.meta.env.VITE_SENTRY_DSN,
    sentryModuleName: 'starterTemplate',
    datadog: {
        clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
        tags: {
            version: import.meta.env.VITE_GIT_VERSION,
            service: import.meta.env.VITE_SERVICE_NAME,
            teamIdentifier: import.meta.env.VITE_TEAM_IDENTIFIER,
            awsAccountId: import.meta.env.VITE_AWS_ACCOUNT_ID,
            awsAccountName: import.meta.env.VITE_AWS_ACCOUNT_NAME,
        },
    },
    applicationName: 'RIO4Rental',
    partnerNetworkOverviewUrl: import.meta.env.VITE_PARTNER_NETWORK_OVERVIEW_URL,
    partnerNetworkOverviewOnboardingUrl: import.meta.env.VITE_PARTNER_NETWORK_OVERVIEW_ONBOARDING_URL,
    eulaUrl: import.meta.env.VITE_EULA_BASE_URL,
    releaseVersion: import.meta.env.VITE_RELEASE_VERSION,
};
